import { getPathWithForwardSlash } from "./getPathWithForwardSlash"
import { removeFirstForwardSlashFromPath } from "./removeFirstForwardSlashFromPath"

interface GetRelativePathFromCodexParams {
  codex: Record<string, string>
  path: string | null
  codexKeyStartsWithForwardSlash: boolean
}

export function getRelativePathFromCodex({
  codex,
  path,
  codexKeyStartsWithForwardSlash,
}: GetRelativePathFromCodexParams) {
  const FALLBACK_PATH_WHEN_NO_PAGE_PATH_WAS_LINKED =
    "/this-is-a-broken-link-because-no-page-was-linked-in-strapi"

  if (!path) {
    return FALLBACK_PATH_WHEN_NO_PAGE_PATH_WAS_LINKED
  }

  const isHomepage = path === "/"

  if (isHomepage) return path

  let pathToBeValidated: string

  if (codexKeyStartsWithForwardSlash) {
    // Content Codex keys start with "/"
    pathToBeValidated = getPathWithForwardSlash(path)
  } else {
    // Link Url Codex keys do NOT start with "/"
    pathToBeValidated = removeFirstForwardSlashFromPath(path)
  }

  const hasPathInCodex = !!codex[pathToBeValidated]

  const FALLBACK_PATH_WHEN_PAGE_NOT_IN_CODEX = getPathWithForwardSlash(path)

  if (!hasPathInCodex) {
    console.error(`${FALLBACK_PATH_WHEN_PAGE_NOT_IN_CODEX} is a broken link`)
    return FALLBACK_PATH_WHEN_PAGE_NOT_IN_CODEX
  }

  const relativePath = getPathWithForwardSlash(codex[pathToBeValidated])

  return relativePath
}
